import React, { useEffect, useLayoutEffect } from "react";
import MetaDecorator from "../../util/MetaDecorator";
import CardPage from "../../components/CardPage.js";

const Servicepage = () => {
  useLayoutEffect(() => {
    // Scroll to top when component mounts - useLayoutEffect runs before paint
    // The scrollable container is the .main-content Box in App.js
    const scrollContainer = document.querySelector('.main-content');
    if (scrollContainer) {
      scrollContainer.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
    }
  }, []);
  
  useEffect(() => {
    // Also scroll after a brief delay to ensure it works
    const timer = setTimeout(() => {
      const scrollContainer = document.querySelector('.main-content');
      if (scrollContainer) {
        scrollContainer.scrollTo(0, 0);
      } else {
        window.scrollTo(0, 0);
      }
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  return (
    <>
      <MetaDecorator
        title="Autogenbots - Services"
        description="Versatile robotic solutions for diverse industries including construction, military, mining, and multi-utility applications"
      />
      <CardPage />
    </>
  );
};

export default Servicepage;
